import { DateTimeFormatExample, DateTimeFormatPartsExample, RelativeTimeFormatExample, DurationFormatExample, NumberFormatExample, CurrencyLocaleComparisonExample, UnitFormatExample, ListFormatExample, PluralRulesExample, SegmenterExample, CollatorExample } from "../../../../src/components/intlapi/examples";
import * as React from 'react';
export default {
  DateTimeFormatExample,
  DateTimeFormatPartsExample,
  RelativeTimeFormatExample,
  DurationFormatExample,
  NumberFormatExample,
  CurrencyLocaleComparisonExample,
  UnitFormatExample,
  ListFormatExample,
  PluralRulesExample,
  SegmenterExample,
  CollatorExample,
  React
};